import type {RefObject} from 'react';
import type {GridApiPro} from '@mui/x-data-grid-pro';
import {gridPaginationModelSelector} from '@mui/x-data-grid-pro';

export const resetToFirstPage = (apiRef: RefObject<GridApiPro | null>) => {
  if (apiRef.current && gridPaginationModelSelector(apiRef).page !== 0) {
    apiRef.current.setPage(0);
  }
};
